import { appPath } from "../appPath";
import { useEffect, useRef } from "react";

import type { PropertyReport } from "./api";


export function PropertyResultFrame({ report }: { report: PropertyReport }) {
  const frameRef = useRef<HTMLIFrameElement | null>(null);

  function sendReport() {
    frameRef.current?.contentWindow?.postMessage(
      { type: "property-report-preview", report },
      window.location.origin,
    );
  }

  useEffect(sendReport, [report]);

  return (
    <iframe
      ref={frameRef}
      className="platform-property-preview-frame"
      title="不动产解析结果预览"
      src={appPath("/prototype/property-result-frame.html")}
      onLoad={sendReport}
    />
  );
}
